import React from 'react';
import { DiamondIcon, StarIcon, WrenchIcon } from 'lucide-react';
import { yearPlan } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per quarter (full class names so Tailwind keeps them). Dark text on gold for contrast. */
const quarterStyles = [{
  band: 'bg-brand text-white',
  star: 'text-brand'
}, {
  band: 'bg-coral text-white',
  star: 'text-coral-ink'
}, {
  band: 'bg-violet text-white',
  star: 'text-violet-ink'
}, {
  band: 'bg-sun text-ink',
  star: 'text-ink'
}];

/** The 52-week plan, quarter by quarter: ★ class starts and ◆ stripe checks */
export function YearPlanSection() {
  return <section id="year" aria-labelledby="year-title" className="scroll-mt-4 bg-white py-12 md:py-20" data-id="element-266" data-mp="32jua27vkca6v">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-267" data-mp="37d6o5o2m8yld">
        <SectionHeading id="year-title" eyebrow={yearPlan.eyebrow} title={yearPlan.title} sub={yearPlan.sub} data-id="element-268" data-mp="29x9hj43cps1q" />

        <ol className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-269" data-mp="2eu9p5jfun2uy">
          {yearPlan.quarters.map((q, qi) => {
          const s = quarterStyles[qi % quarterStyles.length];
          return <li key={q.q} className="flex flex-col overflow-hidden rounded-xl border border-hair bg-white" data-id="element-270" data-mp="1vb69j8fz35ox" data-mpi={qi}>
                <div className={`flex items-baseline justify-between gap-3 px-5 py-3 ${s.band}`} data-id="element-271" data-mp="1qi3awlwc961v">
                  <span className="font-display text-[1.6rem] font-black leading-none" data-id="element-272" data-mp="1lkl4p39ph4xk">{q.q}</span>
                  <span className="font-display text-[12px] font-extrabold tracking-[0.1em]" data-id="element-273" data-mp="1gn1m5r5z65zt">{q.weeks}</span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-274" data-mp="17ksf5b9x0ur6">
                  <h3 className="font-display text-[16px] font-black tracking-[0.04em] text-ink" data-id="element-275" data-mp="17lbymwf7rr7b">{q.name}</h3>
                  <ul className="mt-4 space-y-3" data-id="element-276" data-mp="12o210tho898e">
                    {q.full.map(m => {
                  const review = 'review' in m && m.review;
                  const Icon = review ? DiamondIcon : StarIcon;
                  return <li key={`${q.q}-${m.week}`} className="flex gap-3" data-id="element-277" data-mp="3g3k80pgw4vl0">
                          <Icon className={`mt-0.5 h-4 w-4 shrink-0 fill-current ${review ? 'text-leaf-ink' : s.star}`} aria-hidden="true" data-id="element-278" data-mp="3kvv7xsbmshdk" />
                          <div className="min-w-0" data-id="element-279" data-mp="375i0dr2nj4or">
                            <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-280" data-mp="3c2rwtqogkgm3">
                              SETTIMANA {m.week} · {m.label}
                            </p>
                            <p className={`font-display text-[15px] font-bold leading-snug ${review ? 'text-leaf-ink' : 'text-brand'}`} data-id="element-281" data-mp="7otfa9ol56fn">{m.title}</p>
                          </div>
                        </li>;
                })}
                  </ul>
                  <p className="mt-auto pt-4 text-[14px] leading-snug text-ink/70" data-id="element-282" data-mp="3uvm4s0nnz8gt">{q.activities}</p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mx-auto mt-6 max-w-[900px] rounded-xl bg-sun-soft p-5 md:mt-8 md:p-6" data-id="element-283" data-mp="2jfxg94uri1dw">
          <div className="flex items-center gap-3" data-id="element-284" data-mp="2btik4313ncwa">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sun text-ink" data-id="element-285" data-mp="26w0h0t9rjrw7">
              <WrenchIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-286" data-mp="2kw1j2c1rl5d9" />
            </span>
            <h3 className="font-display text-[14px] font-black tracking-[0.08em] text-ink" data-id="element-287" data-mp="2fvx26kwy28mi">{yearPlan.toolsTitle}</h3>
          </div>
          <ul className="mt-4 grid gap-2.5 md:grid-cols-3 md:gap-4" data-id="element-288" data-mp="1s7ngdizqdkvd">
            {yearPlan.tools.map(t => <li key={t} className="rounded-lg bg-white px-4 py-3 text-[15px] font-medium leading-snug text-ink" data-id="element-289" data-mp="1o73n4qia31ei">
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}